<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { ReportTabsTypes } from '@/entities/Report'
import { useResendMeterData } from './../model/api'
import { useCabinetReports } from '@/pages/object/CabinetReports'
import { useAuth } from '@/entities/Auth'

const route = useRoute()
const model = useCabinetReports()
const { send, isPending } = useResendMeterData()
const { isPermissions } = useAuth()

/** Вычисляем данные для отправки */
const meter = computed(() => model.filter.meter)
const type = computed(() => {
  return route.params.report_type === ReportTabsTypes.READINGS.id ? 'statement' : 'instant'
})
</script>

<template>
  <VBtn
    color="warning"
    :loading="isPending"
    @click="() => send(meter, type)"
    :class="{ disabled: !isPermissions(['DEVICE_CONTROL']) }"
  >
    {{ $t('itf.get_to_cabinet') }}
  </VBtn>
</template>
